/** @format */

import axios, { Method, ResponseType, AxiosError } from 'axios';
// @ts-ignore
import { ManywattClient } from './services/index.ts';

export const getApiUrl = () => {
  const url = import.meta.env.VITE_API_URL || 'http://localhost:8000';
  if (
    url !== axios.defaults.baseURL &&
    axios.defaults.baseURL &&
    axios.defaults.baseURL !== ''
  ) {
    return axios.defaults.baseURL;
  }
  axios.defaults.baseURL = url;
  return url;
};

export const createUrl = (endpoint: string) =>
  `${getApiUrl()}${!getApiUrl().endsWith('/') ? '/' : ''}${
    endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
  }`;

const isAbsolute = (endpoint: string) => /^https?\/\//.test(endpoint);

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.withCredentials = true;
// axios.defaults.baseURL = url;

/**
 * Send a request to API
 * @param method
 * @param endpoint
 * @param params
 * @param data
 * @param headers
 * @param responseType
 * @returns {AxiosPromise}
 */
const request = (
  method: Method,
  endpoint: string,
  params = {},
  data = {},
  headers = {},
  responseType: ResponseType = 'json',
  config = {},
) =>
  axios
    .request({
      method,
      url: endpoint,
      params,
      data,
      headers,
      responseType,
      ...config,
    })
    .catch((error) => {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.detail ===
          "Informations d'authentification non fournies."
      ) {
        if (endpoint !== '/whoami/') {
          window.location.href = '/login/';
        }
      }
      throw error;
    });

const requests = {
  /**
   * Send a GET request to API
   * @param endpoint
   * @param params
   * @param headers
   * @param responseType
   * @param config - Additional axios config (e.g., { signal })
   * @returns {AxiosPromise}
   */
  get: (
    endpoint: string,
    params = {},
    headers = {},
    responseType: ResponseType = 'json',
    config = {},
  ) =>
    request('get', endpoint, params, undefined, headers, responseType, config),
  /**
   * Send a POST request to API
   * @param endpoint
   * @param params
   * @param data
   * @param headers
   * @param responseType
   * @returns {AxiosPromise}
   */
  post: (
    endpoint: string,
    params = {},
    data = {},
    headers = {},
    responseType: ResponseType = 'json',
  ) => request('post', endpoint, params, data, headers, responseType),
  /**
   * Send a PUT request to API
   * @param endpoint
   * @param params
   * @param data
   * @param headers
   * @returns {AxiosPromise}
   */
  put: (endpoint: string, params = {}, data = {}, headers = {}) =>
    request('put', endpoint, params, data, headers),
  /**
   * Send a PATCH request to API
   * @param endpoint
   * @param params
   * @param data
   * @param headers
   * @returns {AxiosPromise}
   */
  patch: (endpoint: string, params = {}, data = {}, headers = {}) =>
    request('patch', endpoint, params, data, headers),
  /**
   * Send a DELETE request to API
   * @param endpoint
   * @param params
   * @param headers
   * @returns {AxiosPromise}
   */
  delete: (endpoint: string, params = {}, headers = {}) =>
    request('delete', endpoint, params, undefined, headers),
  /**
   * Send a OPTIONS request to API
   * @param endpoint
   * @param params
   * @param headers
   * @returns {AxiosPromise}
   */
  options: (
    endpoint: string,
    params = {},
    headers = {},
    responseType: ResponseType = 'json',
  ) => request('options', endpoint, params, undefined, headers, responseType),
  /**
   * Send a GET request to download from API
   * @param endpoint
   * @param params
   * @param headers
   * @returns {AxiosPromise}
   */
  download: (
    endpoint: string,
    params = {},
    headers = {
      'Content-Type': 'application/json',
      // Accept: 'application/pdf',
    },
  ) => request('get', endpoint, params, {}, headers, 'arraybuffer'),
  /**
   * Send a POST request to download from API
   * @param endpoint
   * @param params
   * @param data
   * @param headers
   * @returns {AxiosPromise}
   */
  downloadPost: (
    endpoint: string,
    params = {},
    data = {},
    headers = {
      'Content-Type': 'application/json',
      // Accept: 'application/pdf',
    },
  ) => request('post', endpoint, params, data, headers, 'arraybuffer'),
};

export { AxiosError };

export const api = requests;

/* const localApi = new OpenAPIClientAxios({ definition: 'http://localhost:8000/api/schema/' });
localApi.init();

export const useApi = () => localApi;

export const axiosInstance = axios.create({
  baseURL: url,
}); */

export const manywattClient = new ManywattClient({
  BASE: getApiUrl(),
  // VERSION: '1.0.0',
  WITH_CREDENTIALS: true,
  CREDENTIALS: 'include',
  // TOKEN: undefined,
  // USERNAME: undefined,
  // PASSWORD: undefined,
  // HEADERS: undefined,
  // ENCODE_PATH: undefined,
});
